import { jsx as _jsx } from "react/jsx-runtime";
import get from 'lodash/fp/get';
import { DateTime } from 'luxon';
export var DateCell = function (_a) {
    var rowData = _a.rowData, column = _a.column;
    var value = get(column.name, rowData);
    return value ? _jsx("span", { className: "cell", children: DateTime.fromISO(value).toFormat('dd. MM. yyyy') }) : null;
};
